import { render } from "./DatosContacto.vue?vue&type=template&id=0141d6a0&scoped=true"
import script from "./DatosContacto.vue?vue&type=script&lang=js"
export * from "./DatosContacto.vue?vue&type=script&lang=js"

import "./DatosContacto.vue?vue&type=style&index=0&id=0141d6a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0141d6a0"

export default script